export const cppa_states = [
    {
        identifier: 'US',
        display_name: {
            en: 'USA',
            fr: 'États-Unis',
        },
        states: [
            {
                identifier: 'california',
                display_name: {
                    en: 'California',
                    fr: 'Californie',
                },
                fsa_start: '90001',
                fsa_end: '96162',
            },
            {
                identifier: 'colorado',
                display_name: {
                    en: 'Colorado',
                    fr: 'Colorado',
                },
                fsa_start: '80001',
                fsa_end: '81658',
            },
            {
                identifier: 'connecticut',
                display_name: {
                    en: 'Connecticut',
                    fr: 'Connecticut',
                },
                fsa_start: '06001',
                fsa_end: '06928',
            },
            {
                identifier: 'utah',
                display_name: {
                    en: 'Utah',
                    fr: 'Utah',
                },
                fsa_start: '84001',
                fsa_end: '84791',
            },
            {
                identifier: 'virginia',
                display_name: {
                    en: 'Virginia',
                    fr: 'Virginie',
                },
                fsa_start: '22002',
                fsa_end: '24658',
            },
            {
                identifier: 'alabama',
                display_name: {
                    en: 'Alabama',
                    fr: 'Alabama',
                },
                fsa_start: '35004',
                fsa_end: '36925',
            },
            {
                identifier: 'alaska',
                display_name: {
                    en: 'Alaska',
                    fr: 'Alaska',
                },
                fsa_start: '99501',
                fsa_end: '99950',
            },
            {
                identifier: 'arizona',
                display_name: {
                    en: 'Arizona',
                    fr: 'Arizona',
                },
                fsa_start: '85001',
                fsa_end: '86556',
            },
            {
                identifier: 'arkansas',
                display_name: {
                    en: 'Arkansas',
                    fr: 'Arkansas',
                },
                fsa_start: '71601',
                fsa_end: '72959',
            },
            {
                identifier: 'delaware',
                display_name: {
                    en: 'Delaware',
                    fr: 'Delaware',
                },
                fsa_start: '19701',
                fsa_end: '19980',
            },
            {
                identifier: 'florida',
                display_name: {
                    en: 'Florida',
                    fr: 'Floride',
                },
                fsa_start: '32004',
                fsa_end: '34997',
            },
            {
                identifier: 'georgia',
                display_name: {
                    en: 'Georgia',
                    fr: 'Géorgie',
                },
                fsa_start: '30002',
                fsa_end: '39901',
            },
            {
                identifier: 'hawaii',
                display_name: {
                    en: 'Hawaii',
                    fr: 'Hawaï',
                },
                fsa_start: '96701',
                fsa_end: '96898',
            },
            {
                identifier: 'idaho',
                display_name: {
                    en: 'Idaho',
                    fr: 'Idaho',
                },
                fsa_start: '83201',
                fsa_end: '83877',
            },
            {
                identifier: 'illinois',
                display_name: {
                    en: 'Illinois',
                    fr: 'Illinois',
                },
                fsa_start: '60001',
                fsa_end: '62999',
            },
            {
                identifier: 'indiana',
                display_name: {
                    en: 'Indiana',
                    fr: 'Indiana',
                },
                fsa_start: '46001',
                fsa_end: '47997',
            },
            {
                identifier: 'iowa',
                display_name: {
                    en: 'Iowa',
                    fr: 'Iowa',
                },
                fsa_start: '50001',
                fsa_end: '52809',
            },
            {
                identifier: 'kansas',
                display_name: {
                    en: 'Kansas',
                    fr: 'Kansas',
                },
                fsa_start: '66002',
                fsa_end: '67954',
            },
            {
                identifier: 'kentucky',
                display_name: {
                    en: 'Kentucky',
                    fr: 'Kentucky',
                },
                fsa_start: '40003',
                fsa_end: '42788',
            },
            {
                identifier: 'louisiana',
                display_name: {
                    en: 'Louisiana',
                    fr: 'Louisiane',
                },
                fsa_start: '70001',
                fsa_end: '71497',
            },
            {
                identifier: 'maine',
                display_name: {
                    en: 'Maine',
                    fr: 'Maine',
                },
                fsa_start: '03901',
                fsa_end: '04992',
            },
            {
                identifier: 'maryland',
                display_name: {
                    en: 'Maryland',
                    fr: 'Maryland',
                },
                fsa_start: '20588',
                fsa_end: '21930',
            },
            {
                identifier: 'massachusetts',
                display_name: {
                    en: 'Massachusetts',
                    fr: 'Massachusetts',
                },
                fsa_start: '01001',
                fsa_end: '02791',
            },
            {
                identifier: 'michigan',
                display_name: {
                    en: 'Michigan',
                    fr: 'Michigan',
                },
                fsa_start: '48001',
                fsa_end: '49971',
            },
            {
                identifier: 'minnesota',
                display_name: {
                    en: 'Minnesota',
                    fr: 'Minnesota',
                },
                fsa_start: '55001',
                fsa_end: '56763',
            },
            {
                identifier: 'mississippi',
                display_name: {
                    en: 'Mississippi',
                    fr: 'Mississippi',
                },
                fsa_start: '38601',
                fsa_end: '39776',
            },
            {
                identifier: 'missouri',
                display_name: {
                    en: 'Missouri',
                    fr: 'Missouri',
                },
                fsa_start: '63001',
                fsa_end: '65899',
            },
            {
                identifier: 'montana',
                display_name: {
                    en: 'Montana',
                    fr: 'Montana',
                },
                fsa_start: '59001',
                fsa_end: '59937',
            },
            {
                identifier: 'nebraska',
                display_name: {
                    en: 'Nebraska',
                    fr: 'Nebraska',
                },
                fsa_start: '68001',
                fsa_end: '69367',
            },
            {
                identifier: 'nevada',
                display_name: {
                    en: 'Nevada',
                    fr: 'Nevada',
                },
                fsa_start: '88901',
                fsa_end: '89883',
            },
            {
                identifier: 'new_hampshire',
                display_name: {
                    en: 'New Hampshire',
                    fr: 'New Hampshire',
                },
                fsa_start: '03031',
                fsa_end: '03897',
            },
            {
                identifier: 'new_jersey',
                display_name: {
                    en: 'New Jersey',
                    fr: 'New Jersey',
                },
                fsa_start: '07001',
                fsa_end: '08989',
            },
            {
                identifier: 'new_mexico',
                display_name: {
                    en: 'New Mexico',
                    fr: 'Nouveau-Mexique',
                },
                fsa_start: '87001',
                fsa_end: '88441',
            },
            {
                identifier: 'new_york',
                display_name: {
                    en: 'New York',
                    fr: 'New York',
                },
                fsa_start: '00501',
                fsa_end: '14975',
            },
            {
                identifier: 'north_carolina',
                display_name: {
                    en: 'North Carolina',
                    fr: 'Caroline du Nord',
                },
                fsa_start: '27006',
                fsa_end: '28909',
            },
            {
                identifier: 'north_dakota',
                display_name: {
                    en: 'North Dakota',
                    fr: 'Dakota du Nord',
                },
                fsa_start: '58001',
                fsa_end: '58856',
            },
            {
                identifier: 'ohio',
                display_name: {
                    en: 'Ohio',
                    fr: 'Ohio',
                },
                fsa_start: '43001',
                fsa_end: '45999',
            },
            {
                identifier: 'oklahoma',
                display_name: {
                    en: 'Oklahoma',
                    fr: 'Oklahoma',
                },
                fsa_start: '73001',
                fsa_end: '74966',
            },
            {
                identifier: 'oregon',
                display_name: {
                    en: 'Oregon',
                    fr: 'Oregon',
                },
                fsa_start: '97001',
                fsa_end: '97920',
            },
            {
                identifier: 'pennsylvania',
                display_name: {
                    en: 'Pennsylvania',
                    fr: 'Pennsylvanie',
                },
                fsa_start: '15001',
                fsa_end: '19640',
            },
            {
                identifier: 'rhode_island',
                display_name: {
                    en: 'Rhode Island',
                    fr: 'Rhode Island',
                },
                fsa_start: '02801',
                fsa_end: '02940',
            },
            {
                identifier: 'south_carolina',
                display_name: {
                    en: 'South Carolina',
                    fr: 'Caroline du Sud',
                },
                fsa_start: '29001',
                fsa_end: '29948',
            },
            {
                identifier: 'south_dakota',
                display_name: {
                    en: 'South Dakota',
                    fr: 'Dakota du Sud',
                },
                fsa_start: '57001',
                fsa_end: '57799',
            },
            {
                identifier: 'tennessee',
                display_name: {
                    en: 'Tennessee',
                    fr: 'Tennessee',
                },
                fsa_start: '37010',
                fsa_end: '38589',
            },
            {
                identifier: 'texas',
                display_name: {
                    en: 'Texas',
                    fr: 'Texas',
                },
                fsa_start: '73301',
                fsa_end: '88595',
            },
            {
                identifier: 'vermont',
                display_name: {
                    en: 'Vermont',
                    fr: 'Vermont',
                },
                fsa_start: '05001',
                fsa_end: '05907',
            },
            {
                identifier: 'washington',
                display_name: {
                    en: 'Washington',
                    fr: 'Washington',
                },
                fsa_start: '98001',
                fsa_end: '99403',
            },
            {
                identifier: 'west_virginia',
                display_name: {
                    en: 'West Virginia',
                    fr: 'Virginie-Occidentale',
                },
                fsa_start: '24701',
                fsa_end: '26886',
            },
            {
                identifier: 'wisconsin',
                display_name: {
                    en: 'Wisconsin',
                    fr: 'Wisconsin',
                },
                fsa_start: '53001',
                fsa_end: '54990',
            },
            {
                identifier: 'wyoming',
                display_name: {
                    en: 'Wyoming',
                    fr: 'Wyoming',
                },
                fsa_start: '82001',
                fsa_end: '83128',
            },
        ],
    },
    {
        identifier: 'CA',
        display_name: {
            en: 'Canada',
            fr: 'Canada',
        },
        states: [
            {
                identifier: 'ontario',
                display_name: {
                    en: 'Ontario',
                    fr: 'Ontario',
                },
                fsa_start: 'K0A',
                fsa_end: 'P9N',
            },
            {
                identifier: 'quebec',
                display_name: {
                    en: 'Quebec',
                    fr: 'Québec',
                },
                fsa_start: 'G0A',
                fsa_end: 'J9Z',
            },
            {
                identifier: 'alberta',
                display_name: {
                    en: 'Alberta',
                    fr: 'Alberta',
                },
                fsa_start: 'T0A',
                fsa_end: 'T9Z',
            },
            {
                identifier: 'british_columbia',
                display_name: {
                    en: 'British Columbia',
                    fr: 'Colombie-Britannique',
                },
                fsa_start: 'V0A',
                fsa_end: 'V9Z',
            },
            {
                identifier: 'manitoba',
                display_name: {
                    en: 'Manitoba',
                    fr: 'Manitoba',
                },
                fsa_start: 'R0A',
                fsa_end: 'R9Z',
            },
            {
                identifier: 'new_brunswick',
                display_name: {
                    en: 'New Brunswick',
                    fr: 'Nouveau-Brunswick',
                },
                fsa_start: 'E1A',
                fsa_end: 'E9Z',
            },
            {
                identifier: 'newfoundland_and_labrador',
                display_name: {
                    en: 'Newfoundland and Labrador',
                    fr: 'Terre-Neuve-et-Labrador',
                },
                fsa_start: 'A0A',
                fsa_end: 'A9Z',
            },
            {
                identifier: 'northwest_territories',
                display_name: {
                    en: 'Northwest Territories',
                    fr: 'Territoires du Nord-Ouest',
                },
                fsa_start: 'X0A',
                fsa_end: 'X9Z',
            },
            {
                identifier: 'nova_scotia',
                display_name: {
                    en: 'Nova Scotia',
                    fr: 'Nouvelle-Écosse',
                },
                fsa_start: 'B0A',
                fsa_end: 'B9Z',
            },
            {
                identifier: 'nunavut',
                display_name: {
                    en: 'Nunavut',
                    fr: 'Nunavut',
                },
                fsa_start: 'X0A',
                fsa_end: 'X9Z',
            },
            {
                identifier: 'prince_edward_island',
                display_name: {
                    en: 'Prince Edward Island',
                    fr: 'Île-du-Prince-Édouard',
                },
                fsa_start: 'C0A',
                fsa_end: 'C9Z',
            },
            {
                identifier: 'saskatchewan',
                display_name: {
                    en: 'Saskatchewan',
                    fr: 'Saskatchewan',
                },
                fsa_start: 'S0A',
                fsa_end: 'S9Z',
            },
            {
                identifier: 'yukon',
                display_name: {
                    en: 'Yukon',
                    fr: 'Yukon',
                },
                fsa_start: 'Y0A',
                fsa_end: 'Y9Z',
            },
        ],
    },
]
